import {ColliderXCallback, ColliderXContainer} from "../../components/colliders/ts/ColliderXContainer";
import *as THREE from "three";
import {ColliderX} from "../../components/colliders/ts/ColliderX";
import VideoContainer from "../../components/annotations/VideoContainer";
import VideoDisplay from "../../components/annotations/VideoDisplay";

export class ColliderXProcessor {


    private readonly _colliderXContainer: ColliderXContainer;
    private videoGroupS06: Record<string,VideoDisplay> = {};
    private videoLists: Record<string,VideoDisplay> = {};
    private audioW01EP01A175: VideoDisplay;
    private _isMuteON = false;

    constructor(camera: THREE.Camera,
                private colliders: Array<THREE.Object3D>,
               private videoContainer: VideoContainer,
               private showWireframe = false) {

        const colliderXs: Array<ColliderX> = [];
        this.colliders.forEach((collider) => {
            colliderXs.push(new ColliderX(collider, showWireframe));
        })
        this._colliderXContainer = new ColliderXContainer(camera, new THREE.Vector3(0.5,0.5,0.5),colliderXs, this.colliderEnter, this.colliderStay, this.colliderExit,showWireframe);


        // @ts-ignore
        this.audioW01EP01A175 = this.videoContainer.videoDisplays["W01EP01A175"] ;



    }

    colliderEnter = (collider:ColliderX):void => {
        console.log("colliderEnter -", collider.colliderName);
        if (this.isMuteON) return;
        if (collider.colliderName === "EntranceCollider") {

           this.audioW01EP01A175.playVideo();

        }

    }

    colliderStay = (collider:ColliderX):void => {
       //console.log("colliderStay -",collider.colliderName)
    }

    colliderExit = (collider:ColliderX):void => {
        if (collider.colliderName === "EntranceCollider") {
            console.log("colliderExit -", collider.colliderName);


        }

    }

    get colliderXContainer(): ColliderXContainer {
        return this._colliderXContainer;
    }
    get isMuteON(): boolean {
        return this._isMuteON;
    }

    set isMuteON(value: boolean) {
        this._isMuteON = value;
    }
}
